import { render } from "./account_settings.vue?vue&type=template&id=1a0b1b00&scoped=true"
import script from "./account_settings.vue?vue&type=script&lang=js"
export * from "./account_settings.vue?vue&type=script&lang=js"

import "./account_settings.vue?vue&type=style&index=0&id=1a0b1b00&lang=scss"
import "./account_settings.vue?vue&type=style&index=1&id=1a0b1b00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0b1b00"],['__file',"src/views/account_center/components/account_settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a0b1b00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a0b1b00', __exports__)) {
    api.reload('1a0b1b00', __exports__)
  }
  
  module.hot.accept("./account_settings.vue?vue&type=template&id=1a0b1b00&scoped=true", () => {
    api.rerender('1a0b1b00', render)
  })

}


export default __exports__